import { useMemo, useRef } from 'react'

type AccumulateFunction<T> = (previousValue: T | undefined, dependencies: unknown[]) => T

export function useAccumulateMemo<T>(
  accumulateFunction: AccumulateFunction<T>,
  dependencies: unknown[],
): T {
  const previousValueRef = useRef<T>(undefined)

  const value = useMemo(() => {
    const newValue = accumulateFunction(previousValueRef.current, dependencies)
    previousValueRef.current = newValue
    return newValue
  }, dependencies)

  return value
}
